import _ from "lodash";
import store from "services/redux/store";
import { setSettings } from "services/redux/data/actions";
import HelperSettingNotifications from "utils/helper-setting-notifications";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchSettings from "utils/fetch/FetchSettings";

export default class FetchCachedSettings
{
	static logName = 'FetchCachedSettings';
	static values = null;
	static cacheUpdatedAt = null;

	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'settings',
				tables: [ 'application_settings' ],
				onExpire: FetchCachedSettings.reload,
				updated_at_max_age: ( 5 * 60 ), // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};

	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess( this.values);
					}
				},
				onExpired: () => {
					this.reload( { callbackSuccess, callbackError, callbackStart } )
				}
		})
			);
		});
	}

	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchSettings.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( settings ) => {
						// Save to object
						this.process( settings );

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, settings, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( settings );
						}
					}
				})
			);
		}
		);
	}

	static process = ( settings ) => {
		this.values = settings;
		store.dispatch( setSettings( this.values ) );
		
		HelperSettingNotifications.validate();
	}
}
